import { computed } from 'vue';
import { useStore } from 'vuex';

/**
 * Thin wrapper over the app's existing theme mechanism.
 *
 * It does NOT introduce a parallel theme system:
 *  - persistence is delegated to the existing Vuex `changeTheme` action,
 *    which already writes localStorage('isTheme');
 *  - light/dark is applied via the same `.dark-mode` class on <html> that
 *    App.vue already rely on.
 */
export function useAppTheme() {
  const store = useStore();

  const theme = computed(() => store.getters.theme);
  const isDark = computed(() => theme.value === 'dark');

  const applyThemeClass = (value) => {
    const root = document.documentElement;
    if (value === 'dark') {
      root.classList.add('dark-mode');
    } else {
      root.classList.remove('dark-mode');
    }
  };

  const setTheme = (value) => {
    const next = value === 'dark' ? 'dark' : 'light';
    applyThemeClass(next);
    store.dispatch('changeTheme', next);
  };

  const toggleTheme = () => {
    setTheme(isDark.value ? 'light' : 'dark');
  };

  return {
    theme,
    isDark,
    setTheme,
    toggleTheme
  };
}
